import React from "react";
import { useDynamicTranslations } from "src/hooks/use-dynamic-translations ";
import Loader from "src/pages/components/loader";

export default function AppLayout({ children }) {
    const { loading } = useDynamicTranslations();

    if (loading) {
        return (
            <Loader/>
        );
    }

    return <>{children}</>;
}
